module.exports = __webpack_public_path__ + "img/logo-menu.73d6cc6e.png";